<template>
    <v-edit-dialog
        :return-value.sync="controlModel"
        large
        persistent
        :cancel-text="$t('cancel')"
        :save-text="$t('change')"
        transition="slide-y-transition"
        @save="setValue"
    >
        <div class="text-decorated-underline">{{ controlModel }}</div>
        <template v-slot:input>
            <v-select
                v-model="controlModel"
                :label="$t('currency')"
                :items="currencies"
                item-text="name"
                item-value="id"
                color="teal lighten-2"
            ></v-select>
        </template>
    </v-edit-dialog>
</template>

<script>
import {ProductsService} from "../../../services";

export default {
    name: "ControlCurrency",
    props: ['controlData'],
    data() {
        return {
            paramName: 'currency',
            controlModel: this.controlData.currency,
        }
    },
    computed: {
        currencies(){
            return this.$store.getters.currencies.map(item=>{
                return item.name.toUpperCase();
            })
        },
    },
    methods: {
        setValue() {
            const currencyId = this.$store.getters.currencies.find(item => {
                return item.name.toUpperCase() === this.controlModel
            }).id;
            const paramData = {
                productId: this.controlData.id,
                value: currencyId
            };

            const emitData = this.controlData;
            emitData['currency'] = this.controlModel;

            this.updateParam(emitData, paramData);
        },
        updateParam(emitData, paramData) {
            ProductsService.updateParam(this.paramName, paramData)
                .then(() => {
                    this.$emit('update', emitData);
                })
                .catch(err => console.log(err));
        }
    }
}
</script>

<style scoped>

</style>
